<div class="page-wrapper compact-wrapper" id="pageWrapper">
  <app-header publicClass="header-public"></app-header>
</div>
<div class="landing-page w-100 bg-info p-0 mtop-100">
  <div class="landing-home">
    <div class="h-50 w-100 p-0 m-0 bg-body-secondary">
      <app-carousel-landing></app-carousel-landing>
    </div>
    <app-home-title></app-home-title>
  </div>
</div>
<div class="h-50 w-100 p-0 m-0 bg-body-secondary">
  <app-home-categories></app-home-categories>
</div>

<div>
  <app-home-best-courses></app-home-best-courses>
</div>

<div class="bg-body-secondary m-2 p-2">
  <app-package-comparison></app-package-comparison>
</div>

<div id="about-us" class="w-100 p-0 m-0">
  <section class="section-space feature-section overflow-hidden" id="feature">
    <div class="container-fluid">
      <div class="title">
        <h2><span class="text-info">About us</span></h2>
      </div>
    </div>
    <div class="container">
      <div class="row g-4 fs-5 text-align-justify">
        Established in July 2023, Shining on Safety is a dedicated entity with a
        fervent commitment to revolutionizing the construction industry.
        Specializing in mentorship and training programs, we aim to empower
        employees and ensure strict adherence to Federal, State, and OSHA
        regulations. Recognizing that our workforce is our most valuable asset,
        we prioritize comprehensive training on OSHA and other regulatory
        standards relevant to their roles.<br /><br />
        At Shining on safety, we believe that instilling a culture of safety is
        paramount. Our mission is to cultivate a genuine desire among employees
        to embrace safety practices daily, ultimately making a significant
        impact in the industry. With a focus on excellence and compliance, we
        aspire to lead the way in fostering a safer and more secure working
        environment for construction professionals.
      </div>
    </div>
  </section>
</div>
<div class="w-100   bg-body-secondary p-0 m-0" style="    padding-bottom: 3rem !important;">
  <div class="row mb-3">
    <img src="assets\homepage\discount\SOS_UNIVERSITY_WEBSITEBANNER.png" alt="Banner" class="img-fluid"
      style="cursor: pointer;" (click)="scrollToContactUs()" />
  </div>
  <div class="container-fluid fluid-space">
    <app-product></app-product>
  </div>
</div>
<div class="w-100 bg-light-subtle p-0 m-0">
  <section class="pb-5 feature-section overflow-hidden" id="feature">
    <div class="container-fluid">
      <div class="title">
        <h2>
          We have over <span class="text-info">40 years of experience</span>
        </h2>
      </div>
    </div>
    <div class="container">
      <div class="row g-4">
        <div class="company-reference col-xxl-6 col-lg-6 col-sm-6 slideInUp">
          <img src="assets/homepage/companies/L7.png" class="w-100" alt="L7 Testimonial" />
        </div>
        <div class="company-reference col-xxl-6 col-lg-6 col-sm-6 slideInUp wow heig">
          <img src="assets/homepage/companies/leaf-river.png" class="w-100" alt="Leaf River Testimonial" />
        </div>
        <div class="company-reference col-xxl-6 col-lg-6 col-sm-6 slideInUp wow">
          <img src="assets/homepage/companies/VMG-MECHANICAL.png" class="w-100" alt="VMG Mechanical Testimonial" />
        </div>
        <div class="company-reference col-xxl-6 col-lg-6 col-sm-6 slideInUp wow">
          <img src="assets/homepage/companies/WALSH.png" class="w-100" alt="Archer Western Testimonial" />
        </div>
      </div>
    </div>
  </section>
</div>

<div id="contact-us" class="w-100 bg-body-secondary p-0 m-0">
  <section class="section-space mofi-demo-section layout overflow-hidden">
    <div class="container-fluid">
      <div class="title">
        <h2>Contact Us</h2>
      </div>
    </div>
    <div class="container-fluid fluid-space">
      <div class="row demo-imgs g-xl-5 g-sm-3">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <form class="theme-form" [formGroup]="form" (submit)="sendEmail()" ngNativeValidate>
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input class="form-control" formControlName="name" id="floatingInput22" type="text" placeholder="" />
                  <label for="floatingInput22">Name</label>
                </div>
                @if (validate && formValidation.isInvalidField(form,'name')) {
                <div class="form-error">
                  <div>{{formValidation.getErrorMessage(form,'name')}}</div>
                </div>
                <br>
                }
              </div>
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input class="form-control" formControlName="email" id="floatingInput22" type="email"
                    placeholder="" />
                  <label for="floatingInput22">Email address</label>
                </div>
                @if (validate && formValidation.isInvalidField(form,'email')) {
                <div class="form-error">
                  <div>{{formValidation.getErrorMessage(form,'email')}}</div>
                </div>
                <br>
                }
              </div>
              <div class="form-group">
                <div class="form-floating">
                  <textarea class="form-control" formControlName="comment" id="message"></textarea>
                  <label for="message">Comments</label>
                </div>
                @if (validate && formValidation.isInvalidField(form,'comment')) {
                <div class="form-error">
                  <div>{{formValidation.getErrorMessage(form,'comment')}}</div>
                </div>
                <br>
                }
              </div>
              <button type="submit" class="btn btn-primary w-100 p-2 mt-2">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="h-25 w-100 bg-primary p-0 m-0 p-5">
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">
      <a class="text-light m-5 p-2 pointer" (click)="scrollToAboutUs()">
        About us
      </a>
    </div>
    <div class="d-flex justify-content-center redes">
      <div>
        <i class="fa fa-facebook"></i>
        <a class="text-light m-5 p-2" href="https://www.facebook.com/people/Shiningonsafety-Socialmedia/61552907206527/"
          target="_blank">Facebook</a>
      </div>
      <div>
        <i class="fa fa-instagram"></i>
        <a class="text-light m-5 p-2" href="https://www.instagram.com/shiningonsafety/" target="_blank">Instagram</a>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-self-end">
    Confidential and proprietary Copyright ©️ Shining on Safety. All Rights Reserved
  </div>
</div>